(function () {
    'use strict';

    angular
        .module('app')
        .factory('preventTemplateCache', preventTemplateCache);

    function preventTemplateCache() {
        var buildVersion = "#.#.#.#";
        return {
            'request': function (config) {
                if (config.url.indexOf('.html') !== -1) {
                    if (config.url.indexOf('?') === -1 && config.url.indexOf("uib/template") === -1)
                        config.url = config.url + '?t=' + buildVersion;
                }
                return config;
            }
        }
    }
})();